import {Notification} from '../navigation/page-layout';
import React, {useEffect, useState} from 'react';
import {AppLayout, SideNavigation} from '@amzn/awsui-components-react';
import {InboundBridgeP2ANode} from './inbound-bridge-p2a-node';
import {InboundBridgeP2P} from './inbound-bridge-p2p';
import {InboundBridgeP2ANetwork} from './inbound-bridge-p2a-network';
import {HelpSidePanel} from '../common/help/help-side-panel';
import {useHelp} from '../hooks/use-help';
import {HELP_CONTENTS} from '../common/help/help-contents';

export function ViewInboundBridge(props: {pushNotification: (notification: Notification) => void}) {
    const [currentHash, setCurrentHash] = useState(window.location.hash);
    const {helpContent, setHelpContent, helpOpen, setHelpOpen} = useHelp();

    useEffect(() => {
        setHelpContent(HELP_CONTENTS.INBOUND_BRIDGE_BUCKETS);

        const handleHashChange = () => {
            setCurrentHash(window.location.hash);
        };

        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);

    const renderContent = () => {
        switch (currentHash) {
            case '#/plan-to-actuals':
                return <InboundBridgeP2ANetwork pushNotification={props.pushNotification} />;
            case '#/plan-to-actuals/nodes':
                return <InboundBridgeP2ANode pushNotification={props.pushNotification} />;
            case '#/plan-to-plan':
                return <InboundBridgeP2P pushNotification={props.pushNotification} />;
            default:
                return <InboundBridgeP2ANetwork pushNotification={props.pushNotification} />;
        }
    };

    return (
        <AppLayout
            content={renderContent()}
            tools={<HelpSidePanel helpContent={helpContent} />}
            toolsOpen={helpOpen}
            onToolsChange={(event) => {
                setHelpOpen(event.detail.open);
            }}
            navigation={
                <SideNavigation
                    header={{
                        href: `#`,
                        text: 'Inbound Bridging',
                    }}
                    items={[
                        {
                            type: 'link-group',
                            text: 'Plan to Actuals',
                            href: `#/plan-to-actuals`,
                            items: [
                                {
                                    type: 'link',
                                    text: 'Warehouse level',
                                    external: false,
                                    href: `#/plan-to-actuals/nodes`,
                                },
                            ],
                        },
                        {
                            type: 'link',
                            text: 'Plan to Plan',
                            external: false,
                            href: `#/plan-to-plan`,
                        },
                    ]}
                    activeHref={currentHash}
                />
            }
        />
    );
}

export enum BridgeType {
    P2A = 'p2a',
    P2P = 'p2p',
}

export type InboundBridgeRecord = {
    date: string;
    node: string;
    granularity: Record<string, string>;
    bucketSeqId: number;
    bucketName: string;
    bucketValue: number;
    bucketError: number;
    lastBucketValue: number;
    bucketWape: string;
};

export type NodeFilterData = {
    node: string;
    balanceDateEarliest: string;
    balanceDateLatest: string;
    balanceDateStart: string;
    balanceDateEnd: string;
    fromHorizonInWeeks: number;
    toHorizonInWeeks: number;
    channels?: string[];
    sourceLocations?: string[];
    ibTypes?: string[];
    tempZones?: string[];
};

export type InboundBridgeBucketRecord = {
    date: string;
    seqId: number;
    name: string;
    value?: number;
    wape?: number;
    wapeContribRescaled?: number;
    wapeContribDebiased?: number;
};
